// The weekly-report CHROME — the archive's own words and the letter FRAME's.
//
// Deliberately NOT here: a letter's title, section headings, quote and sign-off.
// Those arrive from the API on `report.content` and differ every week; the
// components only render what they are handed, and the suites read those
// expectations off the fixture rather than from a constant.

/** The weekday ruler under the message sparkline. Positional — index 0 is the
 *  week's first day — so a spark of any length labels from the left. */
export const WEEKDAY_LABELS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

/** Ruler fallback for a spark longer than a week: "D8", "D9", … */
export function weekdayLabel(index: number): string {
  return WEEKDAY_LABELS[index] ?? `D${index + 1}`;
}

export const REPORTS_PAGE_COPY = {
  eyebrow: "Weekly reports",
  title: "Weekly reports",
  sub: "A calm read on each week, newest first. Shared with you both.",
  /** Accessible name of the icon-only back circle. */
  backLabel: "Back to home",
  loadingLabel: "Loading weekly reports...",
  newChip: "New",
  loadMoreLabel: "View more",
  loadingMoreLabel: "Loading…",
  emptyTitle: "No reports yet",
  emptyBody: "Your first Sunday letter will appear here when it is ready.",
  weekOf: (formattedDate: string) => `Week of ${formattedDate}`,
} as const;

export const REPORT_DETAIL_COPY = {
  backLabel: "Back to reports",
  loadingLabel: "Loading weekly report...",
  errorTitle: "Report unavailable",
  errorBody: "Please go back to the archive and try again.",
  sparkLabel: "Message volume over the week",
  balance: {
    positive: "Positive",
    negative: "Negative",
    ariaLabel: (positivePct: number, negativePct: number) =>
      `Positive ${positivePct}%, Negative ${negativePct}%`,
  },
  try: {
    instead: "Instead of",
    better: "Try",
  },
} as const;
